/* tslint:disable */
/* eslint-disable */
export enum SeatsAmountEnum {
  LESS_THAN_10 = 'Less_Than_10',
  FROM_10_TO_100 = 'From_10_to_100',
  FROM_100_TO_1000 = 'From_100_to_1000',
  FROM_1000_TO_10000 = 'From_1000_to_10000',
  MORE_THAN_10000 = 'More_Than_10000'
}
